import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IconKey } from '../../../../whitelabel/icon-key.enum';
import { ButtonComponent } from '../../../osp-ui/components/button/button/button.component';
import { MenuComponent } from '../../../osp-ui/components/menu/menu/menu.component';
import { ActionOption } from '../../contract/action-option.contract';

@Component({
  selector: 'osp-action-panel',
  standalone: true,
  imports: [ButtonComponent, AsyncPipe, NgTemplateOutlet, FormsModule, MenuComponent],
  templateUrl: './action-panel.component.html',
  styleUrl: './action-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActionPanelComponent {
  protected IconKey = IconKey;

  $actions = input<ActionOption[]>([], { alias: 'actions' });

  private $actionSeparator = computed(() => this.separateActions(this.$actions()));
  $leftSectionActions = computed(() => this.$actionSeparator()?.left);
  $rightSectionActions = computed(() => this.$actionSeparator()?.right);

  private separateActions(actions: ActionOption[]): { left: ActionOption[]; right: ActionOption[] } {
    return (actions || []).reduce(
      (acc, action) => {
        const pos = action.position ?? 'left';
        return { ...acc, [pos]: [...acc[pos], action] };
      },
      { left: [], right: [] },
    );
  }

  trackBy(action: ActionOption): string {
    return action.action + ' ' + action.category + action.label + action.position;
  }
}
